export default "__VITE_ASSET__C_bUBh62__"